/**
 * User-facing error/success feedback. Errors always carry the server request id ("Ref: 7f3a…") for support.
 * Uses the site's aria-live toast (@ui/toast), never alert()/confirm().
 */
import { toast } from '@ui/toast';
import { ApiError } from '@app/core/http';

const MESSAGES: Record<string, string> = {
  stale_version: 'Someone else changed this just now. Reload to see their change.',
  forbidden: "You don't have permission to do that.",
  not_found: 'Not found in this business.',
  telephony_unavailable: 'Calling is unavailable right now.',
  payments_unavailable: 'Payments are unavailable right now.',
  tech_at_capacity: 'That tech is already booked in this window.',
  rate_limited: 'Too many requests. Try again in a moment.',
  not_available: 'Rolling out: this action is not available yet.',
  import_target_unavailable: 'Rolling out: this import type is not available yet.',
  tax_rate_missing: 'Set your sales tax before invoicing (Settings → Sales tax).',
  step_required: 'This step is required and can’t be skipped.',
};

export function errorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.status === 0 || e.code === 'network') return "Couldn't reach the server.";
    return MESSAGES[e.code] ?? (e.status >= 500 ? 'Something went wrong on our side.' : e.code.replace(/_/g, ' '));
  }
  if (e instanceof TypeError) return "Couldn't reach the server.";
  return e instanceof Error ? e.message : 'Something went wrong.';
}

export function toastError(e: unknown, title = "That didn't work") {
  const ref = e instanceof ApiError ? e.ref : '';
  toast({ title, body: [errorMessage(e), ref].filter(Boolean).join(' · '), tone: 'danger', duration: 8000 });
}
export const toastOk = (title: string, body?: string) => toast({ title, body, tone: 'done' });
export const toastInfo = (title: string, body?: string) => toast({ title, body, tone: 'neutral' });
